export const shareHighlightStrings = {
  action: 'Share highlight',
  manageAccess: 'Manage access',
  title: 'Share highlight',
  subtitle: 'Preview exactly what you will share.',
  shareTitle: 'Title for this share',
  shortenTitle: 'Shorten the title so it fits in the image. Your saved entry will not change.',
  layout: 'Layout',
  portrait: 'Post',
  portraitRatio: '4:5',
  fullScreen: 'Story',
  fullScreenRatio: '9:16',
  includeReview: 'Include my review',
  addPhoto: 'Add photo',
  changePhoto: 'Change photo',
  photoSource: 'Photo',
  takePhoto: 'Take photo',
  choosePhoto: 'Choose photo',
  removePhoto: 'Remove photo',
  editPhoto: 'Adjust photo',
  photoPrivacy: 'This photo is used only for this share and is not saved to your Hobtalk entry.',
  photoPermission: 'Choose a photo you have permission to share.',
  zoom: 'Zoom',
  horizontalPosition: 'Horizontal position',
  verticalPosition: 'Vertical position',
  reset: 'Reset',
  done: 'Done',
  cancel: 'Cancel',
  photoFailed: 'We could not read that photo. Choose another image.',
  share: 'Share',
  download: 'Download image',
  preparing: 'Preparing image...',
  close: 'Close',
  footer: 'Explore your hobbies with Hobtalk',
  website: 'hobtalk.com',
  shareFailed: 'We could not prepare this highlight. Please try again.',
  sharedDetails: 'Shared details',
  sharedDetailsSummary: 'Choose what appears in this export.',
  saveDefaults: 'Save as my default',
  defaultSaved: 'Sharing defaults saved.',
};

export const externalShareDefaults = {
  shareHighlights: {
    showDisplayName: false,
    useEntryPhotos: true,
    includeReviews: false,
    includeRatings: true,
    showExactDates: false,
    showPlaceNames: true,
    includeDetailedMetrics: true,
  },
  insightRecaps: {
    showDisplayName: false,
    useEntryPhotos: false,
    includeReviews: false,
    includeRatings: true,
    showExactDates: false,
    showPlaceNames: false,
    includeDetailedMetrics: true,
  },
};

export const externalSharePreferenceOptions = [
  { key: 'showDisplayName', label: 'Show display name' },
  { key: 'useEntryPhotos', label: 'Use saved entry photos' },
  { key: 'includeReviews', label: 'Include review text' },
  { key: 'includeRatings', label: 'Include ratings' },
  { key: 'showExactDates', label: 'Show exact dates' },
  { key: 'showPlaceNames', label: 'Show destination and trail names' },
  { key: 'includeDetailedMetrics', label: 'Include detailed metrics' },
];

export function resolveExternalSharingPreferences(value) {
  return {
    shareHighlights: { ...externalShareDefaults.shareHighlights, ...(value?.shareHighlights || {}) },
    insightRecaps: { ...externalShareDefaults.insightRecaps, ...(value?.insightRecaps || {}) },
  };
}
